__webpack_require__.p = "/public/v2/tournaments/";